import http from '../plugins/axios'

export const getAllSourcingRequestList = async (params) => {
  try {
    const response = await http.get(`/api/v2/products-request`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}

export const addSourcingRequest = async (payload) => {
  try {
    const response = await http.post(`/api/v2/products-request`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const updateSourcingRequest = async (sourcingId, payload) => {
  try {
    const response = await http.put(`/api/v2/products-request/${sourcingId}`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const deleteSourcingRequest = async (sourcingId) => {
  try {
    const response = await http.delete(`/api/v2/products-request/${sourcingId}`)
    return response.data
  } catch(error) {
    throw error
  }
}

export const submitQuoteSourcingRequest = async (sourcingId) => {
  try {
    const response = await http.post(`/api/v2/products-request/${sourcingId}/request-quote`)
    return response.data
  } catch(error) {
    throw error
  }
}

export const uploadDocumentSourcingRequest = async (sourcingId, payload) => {
  try {
    const response = await http.post(`/api/v2/products-request/${sourcingId}/documents`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const generateUrlPublicSourcingRequest = async (sourcingId) => {
  try {
    const response = await http.post(`/api/v2/products-request/${sourcingId}/generate-url`)
    return response.data
  } catch(error) {
    throw error
  }
}

export const generateShortUrlSourcingRequest = async (sourcingId) => {
  try {
    const response = await http.post(`/api/v2/products-request/${sourcingId}/short-url`)
    return response.data
  } catch(error) {
    throw error
  }
}

export const deleteDocumentSourcingRequest = async (sourcingId, payload) => {
  try {
    const response = await http.delete(`/api/v2/products-request/${sourcingId}/document`, { data: payload })
    return response.data
  } catch(error) {
    throw error
  }
}

